import { render, staticRenderFns } from "./ContentDiscoveryCustom.vue?vue&type=template&id=73ee4bcf&scoped=true&"
import script from "./ContentDiscoveryCustom.vue?vue&type=script&lang=js&"
export * from "./ContentDiscoveryCustom.vue?vue&type=script&lang=js&"
import style0 from "./ContentDiscoveryCustom.vue?vue&type=style&index=0&id=73ee4bcf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ee4bcf",
  null
  
)

export default component.exports